import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from './BlogData';
import BlogHeader from './BlogHeader';
import './Blog.css';

const BlogHome = () => {
  const [query, setQuery] = useState('');
  const [tagFilter, setTagFilter] = useState('all');

  const sorted = [...blogPosts].sort((a, b) => new Date(b.date) - new Date(a.date));

  const matchesQuery = (post) =>
    post.title.toLowerCase().includes(query.toLowerCase()) ||
    post.excerpt.toLowerCase().includes(query.toLowerCase());
  const matchesTag = (post) => tagFilter === 'all' || post.tag === tagFilter;

  const filteredPinned = sorted.filter((post) => post.pinned && matchesQuery(post));
  const filteredPosts = sorted.filter((post) => !post.pinned && matchesQuery(post) && matchesTag(post));

  return (
    <div>
      <BlogHeader />
      <div className="blog-container">
        <div className="blog-intro">
          <h1>Welcome to the Blog</h1>
          <p>
            A collection of (human generated) thoughts, projects, and personal essays. Exploring ideas in technology,
            philosophy, and life. Minimal, honest, and (hopefully) useful.
          </p>
        </div>

        <input
          type="text"
          placeholder="Search posts..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="blog-search-input"
        />

        {filteredPinned.length > 0 && (
          <div className="blog-pinned-section">
            <p className="blog-section-label">pinned</p>
            {filteredPinned.map((post) => (
              <div className="blog-post-preview" key={post.slug}>
                {post.image && (
                  <div className="blog-post-image">
                    <img src={post.image} alt={post.title} />
                  </div>
                )}
                <div className="blog-post-info">
                  <h2><Link to={`/blog/${post.slug}`}>{post.title}</Link></h2>
                  <p className="blog-post-meta">
                    {post.date}
                    {post.tag && <span className={`blog-tag blog-tag--${post.tag}`}>{post.tag}</span>}
                  </p>
                  <p>{post.excerpt}</p>
                  <Link className="read-more" to={`/blog/${post.slug}`}>Read more →</Link>
                </div>
              </div>
            ))}
            <div className="blog-section-divider" />
          </div>
        )}

        <div className="blog-tag-filter">
          <span className="blog-tag-filter-label">filter</span>
          {['all', 'human', 'ai-slop'].map((t) => (
            <button
              key={t}
              className={`blog-tag-filter-btn${tagFilter === t ? ' active' : ''}`}
              onClick={() => setTagFilter(t)}
            >
              {t}
            </button>
          ))}
        </div>
        <p className="blog-aislop-note">
          * <em>ai-slop</em> — ideas I had but didn't feel like doing the writing for. Mostly extra content for the graph...
        </p>

        {filteredPosts.map((post) => (
          <div className="blog-post-preview" key={post.slug}>
            {post.image && (
              <div className="blog-post-image">
                <img src={post.image} alt={post.title} />
              </div>
            )}
            <div className="blog-post-info">
              <h2><Link to={`/blog/${post.slug}`}>{post.title}</Link></h2>
              <p className="blog-post-meta">
                {post.date}
                {post.tag && <span className={`blog-tag blog-tag--${post.tag}`}>{post.tag}</span>}
              </p>
              <p>{post.excerpt}</p>
              <Link className="read-more" to={`/blog/${post.slug}`}>Read more →</Link>
            </div>
          </div>
        ))}

        {filteredPinned.length === 0 && filteredPosts.length === 0 && (
          <p style={{ color: '#999', marginTop: '2rem' }}>No posts found.</p>
        )}
        <div className="post-signoff">
          <p>
            Hello, Old Sport. <br/>
            <br/>
            I think you should <br/>
            choose the coffee. <br/> 
            <br/>
            -- jake.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BlogHome;
